import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { TbAlertTriangle } from "react-icons/tb";
import logo from "../assets/cogniflock_logo_full.svg";
import { getApiBaseUrl } from "../utils/apiConfig";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiUrl = getApiBaseUrl();
      await axios.post(`${apiUrl}/auth/forgot-password`,
        { email }
      );
      navigate("/password-reset-confirmation", { state: { email } });
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          "No user found with that email" ||
          "Error resetting password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
      <div className="w-full max-w-sm p-6 flex flex-col gap-10">
        <img src={logo} alt="Logo" className="h-9" />{" "}
        <div className="relative w-full flex flex-col gap-3">
          <div className="w-full max-w-md flex flex-col gap-4 p-6 bg-white-f border border-grey-20 rounded-xl shadow-sm">
            <div className="flex flex-col gap-2 mb-3">
              {" "}
              <h2 className="text-xl  font-normal text-black-0">
                Forgot Password
              </h2>
              <p className="text-sm  font-normal text-grey-60">
                Enter your email address to receive a password reset link.{" "}
              </p>
            </div>
            <form
              onSubmit={handleForgotPassword}
              className="flex flex-col gap-7"
            >
              <div className="flex flex-col gap-1">
                <label className="text-grey-60 text-sm  font-medium">
                  Email
                </label>
                <input
                  className="w-full px-3 py-1 border border-grey-30 rounded-md focus:outline-none"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <button
                className="w-full py-2 px-4  bg-brand text-white-f text-sm  font-medium tracking-wide rounded-md hover:bg-brand-dark transition"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <div className="inline-block align-middle w-4 h-4 border-2 border-t-2 border-t-white-f border-bg-opacity rounded-full animate-spin"></div>
                ) : (
                  "Send reset link"
                )}
              </button>
              {error && (
                <div className="flex gap-2 items-center text-center">
                  <TbAlertTriangle className="size-5 text-red-strong" />{" "}
                  <p className="text-red-strong text-sm  font-normal ">
                    {error}
                  </p>
                </div>
              )}
            </form>
            <p className="mt-2  font-normal text-center text-sm text-grey-60">
              Remember your password?{" "}
              <Link
                to="/login"
                className="font-semibold text-brand hover:underline"
              >
                Sign In
              </Link>
            </p>
          </div>
          {/* Decorative lines */}
          <div className="absolute -top-20 -bottom-8 -left-2 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-20 -right-2 -bottom-8 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -bottom-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
